import React from 'react';
import { AreaCountRow } from '../../types';
import { useFilters } from '../../cube/filters';
import { D3BarChart } from './D3BarChart';

interface AreaDistributionBarProps {
  data: AreaCountRow[];
}

const AREA_TIER_ORDER: Record<string, number> = {
  '0-30m²': 1,
  '30-50m²': 2,
  '50-70m²': 3,
  '70-100m²': 4,
  '100-150m²': 5,
  '150-200m²': 6,
  '200-300m²': 7,
  '300+m²': 8,
};

export const AreaDistributionBar: React.FC<AreaDistributionBarProps> = ({ data }) => {
  const { filters, set } = useFilters();
  const selected = filters.areaTier || [];

  const series = (data || [])
    .map((d) => ({
      key: d.area_tier,
      value: Number(d.count),
      order: AREA_TIER_ORDER[d.area_tier] || 0,
    }))
    .sort((a, b) => a.order - b.order);

  const formatAreaLabel = (key: string | number) => {
    const sKey = String(key);
    if (sKey === '0-30m²') {
      return '30m²';
    }
    if (sKey === '200-300m²') {
      return '300m²';
    }
    if (sKey.includes('+')) {
      return '301m²+';
    }
    const parts = sKey.split('-');
    if (parts.length > 1) {
      return parts[1];
    }
    return sKey;
  };

  return (
    <D3BarChart
      data={series}
      title="Distribuição por Tamanho"
      xLabel="Tamanho"
      yLabel="Quantidade"
      selectedKeys={selected}
      onBarClick={(key) => {
        const k = String(key);
        const active = selected.includes(k);
        set({ areaTier: active ? undefined : [k] });
      }}
      formatXTick={formatAreaLabel}
      formatYTick={(n) => String(Math.round(n))}
    />
  );
};
